import React from 'react';

import styles from './TemporaryBadge.module.scss';

export const TemporaryBadge: React.FC = () => {
  return <span className={styles.temporaryBadge}>Temporary</span>;
};
